export default "<p>Kiosk-mode is now enabled!</p>\r\n"